import { render, staticRenderFns } from "./board.vue?vue&type=template&id=c821e338&scoped=true&"
import script from "./board.vue?vue&type=script&lang=js&"
export * from "./board.vue?vue&type=script&lang=js&"
import style0 from "./board.vue?vue&type=style&index=0&id=c821e338&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c821e338",
  null
  
)

export default component.exports